export default "__VITE_ASSET__c71250c0__"